/**
 * 통신주기 필터 설정은 운영 중 바뀌므로 `utils/config/serverCycleConfig` 로 옮겼다.
 * 화면에서는 `useServerCycleSetting(officeId)` 훅을 쓴다.
 */

export const leakModelHandler = (serverName: any, officeID: any) => {
  switch (serverName) {
    default:
      return '2'
  }
}

/**
 * 행 클릭 시 사진 모달을 열지(아니면 수용가 상세를 열지)는 사업소마다 다르고 운영 중
 * 바뀌므로 `utils/config/photoConfig` 로 옮겼다.
 * 컬럼 정의에서는 `isPhotoModalOffice(officeId)`, 화면에서는 `usePhotoModalOffice` 를 쓴다.
 */

/**
 * 정보, 현황 탭 외함, 외표기 표기 유무, 엑셀 다운로드 기능
 */
export const outerInstallShowHandler = (serverName: any, officeId: any) => {
  const officeID = String(officeId).slice(0, 2)
  switch (serverName) {
    case 'prod':
      switch (officeID) {
        /**
         * 진주 84
         * 창녕 A1
         * 광주 60
         */
        case '84':
        case 'A1':
        case '60':
          return true
        default:
          return false
      }

    case 'dev':
      switch (officeID) {
        case '84':
        case 'A1':
          return true
        default:
          return false
      }
    default:
      return false
  }
}

/**
 *  부산 일때 이미지 클릭시 카카오 맵열리는거 방지용
 *  정보 조회에서는 !로 반대로 사용중
 * @param serverName
 * @param officeId
 * @returns boolean
 */
export const showBusanInfoHandler = (serverName: any, officeId: any) => {
  const officeID = String(officeId).slice(0, 2)
  switch (serverName) {
    case 'prod':
    case 'dev':
      switch (officeID) {
        case '13':
          return false
        default:
          return true
      }
    default:
      return true
  }
}

/**
 *  부산 전용 엑셀 다운로드 단말기번호 추가
 * @param serverName
 * @param officeId
 * @returns boolean
 */
export const showBusanExcelHandler = (serverName: any, officeId: any) => {
  const officeID = String(officeId).slice(0, 2)

  switch (serverName) {
    case 'prod':
    case 'dev':
      switch (officeID) {
        case '13':
          return true
        default:
          return false
      }
    default:
      return false
  }
}

export const cooperationHandler = (serverName: any, officeId: any) => {
  const officeID = String(officeId).slice(0, 2)
  switch (serverName) {
    case 'prod':
    case 'dev':
      switch (officeID) {
        case '56':
        case 'CN':
          return true
        default:
          return false
      }
    default:
      return false
  }
}

export const showTemperatureHandler = (serverName: any, officeId: any) => {
  const officeStr = String(officeId ?? '')
  const allowedOfficeIds = [
    '65', // 나주
    '91', // 경산
    'B2', // 영월
    'D1',
    'D4', // 성주
    '00', // 테스트 사업소 or 진천 테스트
    '48', // 구미
    'C4', // 군산
    'Z8', // 진천
    '84', // 진주
    '47', // 김천
    '6512', //봉화,
  ]

  const isAllowed = allowedOfficeIds.some((id) => officeStr.slice(0, id.length) === id)

  switch (serverName) {
    case 'prod':
    case 'dev':
      return isAllowed
    default:
      return false
  }
}

const isFlip180 = (rotate: number): string => {
  const needFlip = (rotate > 90 && rotate < 270) || (rotate < -90 && rotate > -270)
  return needFlip ? 'rotate(180deg)' : `rotate(0deg)`
}

/**
 * 무주 사업소 요청사항에 때라 만들어둔 imageRotateHandler
 * 사업소, 단말기 타입에 따른 이미지 rotate 변환 기능
 */
export const imageRotateHandler = (rotate: any, officeId: any, type: any) => {
  const rotateValue = Number(rotate)
  const officeID = String(officeId).slice(0, 2)

  if (Number.isNaN(rotateValue)) {
    return 'rotate(0deg)'
  }

  switch (officeID) {
    case '01':
      switch (type) {
        case 'PRV':
          return `rotate(${rotateValue}deg)`

        default:
          return isFlip180(rotateValue)
      }

    default:
      return isFlip180(rotateValue)
  }
}

/**
 * HDM 메뉴 노출 여부
 * 구미, 청도, 김천 노출 중
 */
export const showHdmMenuHandler = (serverName: any, officeId: any, accountType?: any) => {
  const officeStr = String(officeId ?? '')
  const allowedOfficeIds = ['48', 'C9', '47', '6512']

  const isAllowed = allowedOfficeIds.some((id) => officeStr.slice(0, id.length) === id)

  switch (serverName) {
    case 'prod':
    case 'dev':
      switch (accountType) {
        case 'sys_admin':
        case 'sys_user':
          return true
        default:
          return isAllowed
      }

    default:
      return false
  }
}
